import './polyfills';
import '@rio-cloud/iframe-resizer/child';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { config } from './config';
import { handleLoginRedirect, main } from './configuration';
import { initDatadogLogs } from './configuration/setup/datadog';
import { store } from './configuration/setup/store';
import { AppContainer } from './features/app/App';
import { ErrorBoundary } from './features/app/ErrorBoundary';

const renderApplication = () => {
    const root = document.getElementById('root');

    // Break the pageLoader as soon as possible without waiting for React to render the Application
    if (root) {
        root.innerHTML = '<div></div>';
    }

    createRoot(root as HTMLElement).render(
        <ErrorBoundary>
            <Provider store={store}>
                <AppContainer />
            </Provider>
        </ErrorBoundary>
    );
};

initDatadogLogs();
if (window.location.href.startsWith(config.login.redirectUri as string)) {
    handleLoginRedirect();
} else {
    main(renderApplication);
}
